/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    TicketTimeLimitOverrideTimeConfigItem,
    TicketTimeLimitOverrideTimeConfigItemFromJSON,
    TicketTimeLimitOverrideTimeConfigItemFromJSONTyped,
    TicketTimeLimitOverrideTimeConfigItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface TicketTimeLimitOverrideListItem
 */
export interface TicketTimeLimitOverrideListItem {
    /**
     * 
     * @type {string}
     * @memberof TicketTimeLimitOverrideListItem
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TicketTimeLimitOverrideListItem
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketTimeLimitOverrideListItem
     */
    deleted?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof TicketTimeLimitOverrideListItem
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof TicketTimeLimitOverrideListItem
     */
    suppliers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof TicketTimeLimitOverrideListItem
     */
    fareTypes?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof TicketTimeLimitOverrideListItem
     */
    carriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {TicketTimeLimitOverrideTimeConfigItem}
     * @memberof TicketTimeLimitOverrideListItem
     */
    time?: TicketTimeLimitOverrideTimeConfigItem;
    /**
     * 
     * @type {number}
     * @memberof TicketTimeLimitOverrideListItem
     */
    dayOffset?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TicketTimeLimitOverrideListItem
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TicketTimeLimitOverrideListItem
     */
    relevance?: number;
}

export function TicketTimeLimitOverrideListItemFromJSON(json: any): TicketTimeLimitOverrideListItem {
    return TicketTimeLimitOverrideListItemFromJSONTyped(json, false);
}

export function TicketTimeLimitOverrideListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketTimeLimitOverrideListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
        'carriers': !exists(json, 'carriers') ? undefined : (json['carriers'] === null ? null : (json['carriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'time': !exists(json, 'time') ? undefined : TicketTimeLimitOverrideTimeConfigItemFromJSON(json['time']),
        'dayOffset': !exists(json, 'dayOffset') ? undefined : json['dayOffset'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
    };
}

export function TicketTimeLimitOverrideListItemToJSON(value?: TicketTimeLimitOverrideListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
        'deleted': value.deleted,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'suppliers': value.suppliers === undefined ? undefined : (value.suppliers === null ? null : (value.suppliers as Array<any>).map(GuidIdAndLabelToJSON)),
        'fareTypes': value.fareTypes === undefined ? undefined : (value.fareTypes === null ? null : (value.fareTypes as Array<any>).map(CodeAndLabelToJSON)),
        'carriers': value.carriers === undefined ? undefined : (value.carriers === null ? null : (value.carriers as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'time': TicketTimeLimitOverrideTimeConfigItemToJSON(value.time),
        'dayOffset': value.dayOffset,
        'allowEdit': value.allowEdit,
        'relevance': value.relevance,
    };
}


